export default {
    getLogsMghabitat: (fromDate, toDate) => {
        return {
            url: '/logs/env/:env',
            method: 'GET',
            route_params: {
                env: 'mghabitat',
            },
            get_params: {
                fromDate,
                toDate,
            },
        };
    },
};



// WEBPACK FOOTER //
// ./environments/logging/data/LogsMghabitat/api.js